import axios from '../../../build/http-requests/axios-common'
import generateDateTime from '../../utils/generateDateTime'
import Vue from 'vue'

export default {
  state: {

  },

  mutations: {
  },

  actions: {
    searchFinancialMovements: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/financialMovements/search', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getFinancialMovByIdTask: ({ commit }, obj) => {
      return new Promise((resolve, reject) => {
        axios.get(obj.url, { params: { idTarefa: obj.idTask } })
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    getFinancialMovementById: ({ commit }, obj) => {
      return new Promise((resolve, reject) => {
        axios.get(obj.url, { params: { idMovimentacaoFinanceira: obj.id } })
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    getHistoricFinancialMovement: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, { params: { idMovimentacaoFinanceira: data.idFinancialMovement } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getAllotmentByMovementId: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, { params: { idMovimento: data.idFinancialMovement } })
        .then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchFinancialMovementsToFile: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/financialMovements/searchFinancialMovementsToFile', filter, {responseType: 'blob'}).then(response => {
          let datetime = generateDateTime()
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', Vue.i18n.translate('downloads.labels.movimentacaoFinanceira') + datetime + '.csv')
          document.body.appendChild(link)
          link.click()
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/financialMovements.js